<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <loading-component>
        <template #content>
            <div class="flex flex-col gap-4 xl:mx-60">
                <div class="flex flex-row items-center gap-4">
                    <back-component></back-component>
                </div>

                <upsert-scope-component v-model="scope" @save="save" />
            </div>
        </template>
    </loading-component>
</template>

<script>
import LoadingComponent from '@/components/LoadingComponent';
import BackComponent from '@/components/BackComponent';
import UpsertScopeComponent from '@/components/scopes/UpsertScopeComponent';
import { mapStores } from 'pinia';
import { useScopesStore } from '@/stores/scopes';
import { useApplicationStore } from '@/stores/application';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'EditScopeView',
    props: ['id'],
    components: { UpsertScopeComponent, BackComponent, LoadingComponent },
    data() {
        return {
            scope: undefined
        };
    },
    async created() {
        this.applicationStore.setLoading(true);
        this.scopesStore.getScope(this.id).then((response) => {
            this.scope = response.data.data;
            this.applicationStore.setLoading(false);
        });
    },
    computed: {
        ...mapStores(useScopesStore, useApplicationStore)
    },
    methods: {
        save(scope) {
            this.scopesStore
                .updateScope(scope)
                .then(() => {
                    Notifications.success('Scope erfolgreich gespeichert');
                })
                .catch((error) => {
                    Notifications.success('Scope konnte nicht gespeichert werden');
                    logger.error('[SCOPE]', error);
                });
        }
    }
};
</script>

<style scoped></style>
